<template>
  <v-container class="px-0 py-6">
    <v-row class="ma-0">
      <v-col v-show="!updateShow" class="px-0 py-0" cols="12" sm="12" md="4">
        <h1>Guias</h1>
        <p class="mb-2">Gerencie as guias do lote.</p>
      </v-col>
      <v-col v-show="updateShow" class="px-0 py-0" cols="12" sm="12" md="4">
        <h1>Edição em massa</h1>
        <p class="mb-2">Edite múltiplas guias e itens.</p>
      </v-col>
      <v-col class="d-flex px-0 py-0" cols="12" sm="12" md="8">
          <v-spacer />
          <v-btn
            outlined
            height="30px"
            small
            color="primary"
            depressed
            class="px-2 ml-3"
            @click="showOpen('critica')"
            >Criticas</v-btn
          >
          <v-btn
            v-show="!updateShow"
            v-if="userData.PermissaoAcoes.faturamento.includes('associarnotafiscal')"
            outlined
            height="30px"
            small
            color="primary"
            depressed
            class="px-2 ml-3"
            @click="showOpen('update_massa')"
            >Edição em massa</v-btn
          >
          <v-tooltip v-else center bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                small
                class="px-2 ml-3"
                depressed
                v-bind="attrs"
                v-on="on"
                >Edição em massa</v-btn
              >
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="border: solid 1px #999;border-radius: 5px;background-color: #fff;"
            >Você não possui permissão para executar esta ação.</span>
          </v-tooltip>
          <v-btn
            v-show="!updateShow"
            v-if="userData.PermissaoAcoes.faturamento.includes('addlote')"
            outlined
            height="30px"
            small
            color="primary"
            depressed
            class="px-2 ml-3"
            @click="deleteGuia()"
            >Excluir guia</v-btn
          >
          <v-tooltip v-else center bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                color="rgb(151 151 151 / 58%)"
                height="30px"
                small
                class="px-2 ml-3"
                depressed
                v-bind="attrs"
                v-on="on"
                >Excluir guia</v-btn
              >
            </template>
            <span
              class="px-3 py-1 ma-0"
              style="border: solid 1px #999;border-radius: 5px;background-color: #fff;"
            >Você não possui permissão para executar esta ação.</span>
          </v-tooltip>
      </v-col>
      <v-col v-show="!updateShow" class="px-0" cols="4">
        <v-text-field
          v-model="formData.search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Filtrar por número, nome ou senha"
          single-line
          outlined
          dense
          hide-details
          @keyup="filterList(formData)"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        search: null,
      },
    };
  },
  props: {
    showOpen: Function,
    userData: Object,
    filterList: Function,
    updateShow: Boolean,
    deleteGuia: Function
  },
};
</script>

